declare global {
  interface Window {
    MSStream: any
  }
}

const checkIosDevice = (): boolean =>
  (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
  !window.MSStream

export default checkIosDevice
